import {MenuItem, TextField} from "@mui/material";
import React from "react";

const PaymentMethodSelect = ({ label, value, onChange }) => {
    const paymentMethods = ["Débito", "Crédito", "PIX", "Dinheiro", "Transferência", "Permuta"];

    return (
        <TextField
            label={label}
            fullWidth
            select
            value={value}
            onChange={onChange}
        >
            {paymentMethods.map((method) => (
                <MenuItem key={method} value={method}>
                    {method}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default PaymentMethodSelect